<section class="tw-my-6 tw-p-4 tw-border tw-border-solid tw-rounded">
  <h2 class="tw-text-lg tw-font-medium">账号资料智能整理</h2>
  <p>粘贴或选择 TXT / CSV / TSV，在本机整理、核对，再由官方密码库客户端加密保存到个人密码库。</p>
  <p class="tw-text-sm">不发送明文文件，不使用外部 AI。所有未知字段默认隐藏保留，不合并重复账号。</p>
  <fieldset [disabled]="draft.busy" class="tw-border-0 tw-p-0">
    <label>内容格式
      <select [(ngModel)]="format" (ngModelChange)="sourceChanged()">
        <option value="auto">自动识别</option><option value="text">中文字段文本</option>
        <option value="csv">CSV 表格</option><option value="tsv">TSV 表格</option>
      </select>
    </label>
    <label class="tw-block tw-my-3">本地资料文件
      <input type="file" accept=".txt,.csv,.tsv,text/plain,text/csv" (change)="readFile($event)" />
    </label>
    <button type="button" (click)="showSource = !showSource">{{ showSource ? '收起原文' : '显示 / 编辑原文（可能含密码）' }}</button>
    <label *ngIf="showSource" class="tw-block">或粘贴资料
      <textarea class="tw-block tw-w-full" rows="6" [(ngModel)]="source" (ngModelChange)="sourceChanged()" (paste)="checkPaste($event)" autocomplete="off" spellcheck="false" placeholder="名称：示例应用&#10;账号：example&#10;密码：虚构值&#10;邮箱：example@example.invalid"></textarea>
    </label>
    <p class="tw-text-sm">粘贴或实际编辑 textarea 会将 CRLF 统一为 LF；多行密码请读取原 CSV/TSV 文件且保持不编辑。密码首尾空白原样保留，请核对。</p>
    <button type="button" (click)="organize()">整理并预览</button>
    <button type="button" (click)="clear()">清空当前资料</button>
    <p role="alert">{{ error }}</p>
    <article *ngFor="let record of draft.records; let index = index" class="tw-my-4 tw-p-3 tw-border tw-border-solid tw-rounded">
      <h3>记录 {{ index + 1 }}</h3>
      <button type="button" (click)="delete(index)">删除这条</button>
      <label class="tw-block">名称 <input [value]="record.name" (input)="edit(index, 'name', $event)" autocomplete="off" /></label>
      <label class="tw-block">网址 <input [value]="record.url" (input)="edit(index, 'url', $event)" autocomplete="off" /></label>
      <label class="tw-block">账号 <input [value]="record.account" (input)="edit(index, 'account', $event)" autocomplete="off" /></label>
      <label class="tw-block">密码
        <input *ngIf="!showPassword.has(record)" type="password" [value]="record.password" readonly autocomplete="off" />
        <textarea *ngIf="showPassword.has(record)" rows="2" [value]="record.password" (input)="edit(index, 'password', $event)" autocomplete="off" spellcheck="false"></textarea>
        <button type="button" (click)="toggle(record)">{{ showPassword.has(record) ? '隐藏' : '显示 / 编辑' }}</button>
      </label>
      <label class="tw-block">用户名 <input [value]="record.username" (input)="edit(index, 'username', $event)" autocomplete="off" /></label>
      <label class="tw-block">手机号 <input [value]="record.phone" (input)="edit(index, 'phone', $event)" autocomplete="off" /></label>
      <label class="tw-block">邮箱 <input [value]="record.email" (input)="edit(index, 'email', $event)" autocomplete="off" /></label>
      <label class="tw-block">备注 <textarea [value]="record.notes" (input)="edit(index, 'notes', $event)" autocomplete="off" spellcheck="false"></textarea></label>
      <div *ngFor="let field of record.extraFields" class="tw-my-2">
        <label>自定义字段名称 <input [(ngModel)]="field.name" (ngModelChange)="draft.edited()" autocomplete="off" /></label>
        <label>值
          <input *ngIf="!showPassword.has(field)" type="password" [value]="field.value" readonly autocomplete="off" />
          <textarea *ngIf="showPassword.has(field)" [(ngModel)]="field.value" (ngModelChange)="draft.edited()" autocomplete="off" spellcheck="false"></textarea>
        </label>
        <button type="button" (click)="toggle(field)">{{ showPassword.has(field) ? '隐藏' : '显示 / 编辑' }}</button>
        <label><input type="checkbox" [(ngModel)]="field.hidden" (ngModelChange)="draft.edited()" />保存为隐藏字段</label>
      </div>
      <ul><li *ngFor="let warning of record.warnings">{{ warning.message }}</li></ul>
      <details *ngIf="record.unparsed.length">
        <summary>有未识别原文（可能含密码，请展开核对；会完整保存在加密备注）</summary>
        <p *ngFor="let line of record.unparsed">第 {{ line.line }} 行：{{ line.text }}</p>
      </details>
    </article>
    <label *ngIf="draft.records.length" class="tw-block tw-my-3">
      <input type="checkbox" [(ngModel)]="draft.confirmed" />已核对所有字段、空白、多行密码与重复记录；保存会创建新条目，不自动去重。
    </label>
    <button type="button" (click)="save()" [disabled]="!draft.confirmed || !draft.records.length || draft.attempted || !userId">加密保存到个人密码库</button>
  </fieldset>
  <p role="status" aria-live="polite">{{ draft.message }}</p>
</section>
